// Module
var code = " <div id=\"main\" class=\"container-fluid\" data-ui-view> <div class=\"restrict-width\"> <p>loading...</p> </div> </div> ";
// Exports
var _module_exports =code;;
var path = 'app/configure/ConfigureContentTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;